import { render, staticRenderFns } from "./ZSkeleton.vue?vue&type=template&id=7fb9e4d0&scoped=true&"
import script from "./ZSkeleton.vue?vue&type=script&lang=js&"
export * from "./ZSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb9e4d0",
  null
  
)

export default component.exports